// extracted by mini-css-extract-plugin
export var button = "_cr-0";
export var icon = "_cr-1";